import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";
import { GOOGLE_MAPS_API_KEY } from "@shared/config";
import { useEffect } from "react";

interface GoogleMapProps {
  lat: number;
  lng: number;
  zoom?: number;
}

export const GoogleMap: React.FC<GoogleMapProps> = ({
  lat,
  lng,
  zoom = 15,
}) => {
  const center = { lat, lng };

  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (
            node instanceof HTMLLinkElement &&
            node.href.includes("fonts.googleapis.com")
          ) {
            node.remove();
          }
        });
      });
    });

    observer.observe(document.head, { childList: true });
    return () => observer.disconnect();
  }, []);

  return (
    <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
      <div className="w-full h-[60vh] rounded-lg shadow-lg overflow-hidden">
        <Map
          defaultCenter={center}
          defaultZoom={zoom}
          gestureHandling="cooperative"
          disableDefaultUI={false}
          mapTypeControl={false}
          streetViewControl={false}
          fullscreenControl={false}
          mapTypeId="satellite"
        >
          <Marker position={center} />
        </Map>
      </div>
    </APIProvider>
  );
};
